import { eventThrottle } from '../../../utility';
import { breakpoints } from '../../../constants';
import scrollOffsets from './scrollOffsets';

export default class flexibleSectionsNavigation {
  constructor(el) {
    this.el = el;

    // Wait for all styles to load in order to avoid incorrect values
    window.addEventListener('load', () => {
      this.navigation = this.el.querySelector('[data-flexible-sections-navigation]');
      this.navigationLightClass = 'flexible-sections__navigation--light';
      this.flexibleSections = this.el.querySelector('[data-flexible-sections]');
      this.sections = this.flexibleSections.children;
      this.flexibleNavItems = this.el.querySelectorAll('[data-flexible-nav-item]');
      this.navList = this.el.querySelector('[data-nav-list]');
      this.activeMobileItem = this.el.querySelector('[data-active-mobile-item]');
      this.navArrow = this.el.querySelector('[data-nav-arrow]');
      this.fixedClass = 'fixed';
      this.activeClass = 'active';
      this.generateElementPositions();
      this.addScrollListener();
      this.addNavigationMarginTop();
      this.addActiveMobileItemListener();
      this.addMobileNavListListener();
      this.addInitialActiveItemText();
      this.addNavItemListeners();
      this.addWindowResizeListener();
    });
  }

  addScrollListener() {
    window.addEventListener('scroll', eventThrottle(() => {
      this.generateElementPositions();
      const scrollTop =  document.documentElement.scrollTop;
      const scrollBottom = scrollTop + window.innerHeight;
      if (scrollBottom > this.flexibleSectionsBottom) {
        if (this.navigation.classList.contains(this.fixedClass)) {
          if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
            const newTop = scrollTop - this.parentTop;
            this.navigation.style.top = `${newTop}px`;
          } else {
            const newTop = scrollTop;
            this.navigation.style.top = `${newTop}px`;
          }
        }
        this.navigation.classList.remove(this.fixedClass);
      } else if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches && scrollTop > this.navigationTop) {
        this.navigation.classList.add(this.fixedClass);
        this.navigation.style.top = '0';
        this.determineActiveSection(scrollTop);
      } else if (!window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches && scrollTop > 0) {
        this.navigation.classList.add(this.fixedClass);
        this.navigation.style.top = `${this.parentTop}px`;
        this.determineActiveSection(scrollTop);
      } else {
        this.navigation.classList.remove(this.fixedClass);
        this.navigation.style.top = '0';
      }
    }), 300);
  }

  determineActiveSection(scrollTop) {
    for (let i = 0; i < this.sections.length; i++) {
      const section = this.sections[i];
      const sectionTop = section.offsetTop;
      const sectionBottom = section.offsetTop + section.offsetHeight;
      let scrollOffset = scrollTop + scrollOffsets['offset-2'];
      if (window.matchMedia(`(min-width: ${breakpoints['break-4']}px)`).matches) {
        scrollOffset = scrollTop + scrollOffsets['offset-1'];
      } else if (window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
        scrollOffset = scrollTop + scrollOffsets['offset-3'];
      }
      if (sectionTop < scrollOffset && scrollOffset < sectionBottom) {
        // Determine active section
        const link = document.querySelector(`a[href='#${section.getAttribute('id')}']`);
        if (!link.parentElement.classList.contains(this.activeClass)) {
          this.removeActiveLink();
          link.parentElement.classList.add(this.activeClass);
        }
        this.activeMobileItem.innerHTML = link.innerHTML;

        // Determine navigation color
        const sectionId = section.getAttribute('id').replace('section-', '');
        const backgroundColor = section.getAttribute('data-background-color');
        if (backgroundColor !== 'default') {
          if (backgroundColor === 'primary-gradient') {
            this.addNavigationLightClass();
          } else if (backgroundColor === 'black') {
            this.addNavigationLightClass();
          } else {
            this.resetBackground();
          }
        } else if (isOdd(sectionId)) {
          this.addNavigationLightClass();
        } else {
          this.resetBackground();
        }
      }
    }
  }

  removeActiveLink() {
    for (let i = 0; i < this.flexibleNavItems.length; i++) {
      this.flexibleNavItems[i].classList.remove(this.activeClass);
    }
  }

  generateElementPositions() {
    // Get offsetTop of the nearest relative positioned ancestor
    // as all children element's offsetTop will not include elements above nearest relative positioned ancestor
    // which will make children element's offsetTop correspond with scrollTop
    this.parentTop = this.el.parentElement.offsetTop;
    this.flexibleSectionsBottom = this.parentTop + this.flexibleSections.offsetTop + this.flexibleSections.offsetHeight;
    this.navigationTop = this.parentTop + this.navigation.offsetTop;
  }

  addNavigationMarginTop() {
    if (!window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
      const marginTop = window.innerHeight - this.parentTop - this.navigation.offsetHeight - 15;
      this.navigation.style.marginTop = `${marginTop}px`;
    } else {
      this.navigation.style.marginTop = 0;
    }
  }

  addActiveMobileItemListener() {
    this.activeMobileItem.addEventListener('click', () => {
      this.navList.classList.add('visible');
      this.activeMobileItem.classList.add('hidden');
      this.navArrow.classList.add('active');
    });
  }

  addMobileNavListListener() {
    this.navList.addEventListener('click', () => {
      if (!window.matchMedia(`(min-width: ${breakpoints['break-2']}px)`).matches) {
        this.navList.classList.remove('visible');
        this.activeMobileItem.classList.remove('hidden');
        this.navArrow.classList.remove('active');
      }
    });
  }

  addInitialActiveItemText() { // Populate the active mobile item with the first item's text
    const firstNavItem = this.flexibleNavItems[0].children[0].innerHTML;
    this.activeMobileItem.innerHTML = firstNavItem;
  }

  addNavigationLightClass() {
    this.navigation.classList.add(this.navigationLightClass);
  }

  resetBackground() {
    this.navigation.classList.remove(this.navigationLightClass);
  }

  addNavItemListeners() {
    for (let i = 0; i < this.flexibleNavItems.length; i++) {
      this.flexibleNavItems[i].addEventListener('click', (e) => {
        e.preventDefault(); // Prevent the default browser scroll behavior
        // Get target section by getting the hash of the anchor tag inside the nav item
        const targetSection = document.querySelector(this.flexibleNavItems[i].children[0].hash);
        window.scroll({ // Manually scroll to the target section so that we can add smooth scroll behavior
          top: targetSection.offsetTop + this.parentTop,
          left: 0,
          behavior: 'smooth',
        });
      });
    }
  }

  addWindowResizeListener() {
    window.addEventListener('resize', eventThrottle(() => {
      this.generateElementPositions();
      this.addNavigationMarginTop();
    }, 200));
  }
}

function isOdd(num) {
  return num % 2;
}
